import Skeleton from "@mui/material/Skeleton";
import { CSSProperties, useState } from "react";

interface ImageProps {
  src?: string;
  style?: CSSProperties;
}

const Image = ({ src, style }: ImageProps) => {
  const [loading, setLoading] = useState(true);
  const handleImageLoad = () => {
    setLoading(false);
  };
  return (
    <>
      {loading && <Skeleton variant="rounded" width="100%" height="100%" />}
      <img
        src={src}
        onLoad={handleImageLoad}
        style={{ display: loading ? "none" : "block", ...style }}
      />
    </>
  );
};

export default Image;
